// Branch defaulting, shared by every "today" view that must open on ONE branch
// (morning huddle, employee shift schedule).
//
// The real resolution runs server-side in /api/me/default-branch — today's
// employee_timetable branch → the employee's home branch → HQ remap — because
// only the session knows which employee is asking. What lives here is the
// client-side fallback for when that call is unavailable, so a branch-scoped
// page always has a branch to open on.
import { apiGet } from './api.js'

// สนามเป้า (head office) runs no clinic, so it is never a useful default →
// อารีย์ stands in for it.
export const HQ_BRANCH_ID = 1
export const FALLBACK_BRANCH_ID = 8

// สนามเป้า is head office — it runs no clinic and rosters nobody, so it is not
// a branch any schedule can be built for. Kept out of every branch picker
// rather than left in to be chosen by mistake (it relabels to "อารีย์ (เดิม
// สนามเป้า)", which reads as a second อารีย์ in the list).
export const pickableBranches = (branches) => (
  (Array.isArray(branches) ? branches : [])
    .filter((b) => Number(b?.id) !== HQ_BRANCH_ID)
    .sort((a, b) => Number(a.id) - Number(b.id))
)

export function normalizeBranchId(id) {
  const n = Number(id) || 0
  if (n === HQ_BRANCH_ID) return FALLBACK_BRANCH_ID
  return n || FALLBACK_BRANCH_ID
}

// The default branch for the logged-in employee: today's timetable branch →
// home branch → HQ remap. Always resolves to a number.
export async function resolveDefaultBranch(me) {
  try {
    const r = await apiGet('/api/me/default-branch')
    if (r && r.branch_id) return Number(r.branch_id)
  } catch { /* fall through to the client-side fallback */ }
  return normalizeBranchId(me?.branch_id)
}
